<script>
import TextfieldAnswer from "../framework/TextfieldAnswer";

import answerMixin from "@mixin/answer.mixin";

export default {
    name: "TextfieldAnswerComponent",
    mixins: [answerMixin],
    methods: {
        compare(instance) {
            return instance instanceof TextfieldAnswer;
        },
    },
};
</script>

<template>
    <v-text-field v-if="state" v-model="value" outlined persistent-hint v-bind="attrs" />
</template>

<style lang="scss" scoped></style>
